import { Layout } from "@/components/Layout";
import { useAuth } from "@/lib/auth-context";
import { BookingCreatePage } from "@/pages/BookingCreatePage";
import { BookingDetailPage } from "@/pages/BookingDetailPage";
import { BookingsPage } from "@/pages/BookingsPage";
import { CompaniesPage } from "@/pages/CompaniesPage";
import { ContactsPage } from "@/pages/ContactsPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { EmailsPage } from "@/pages/EmailsPage";
import { HealthPage } from "@/pages/HealthPage";
import { LexofficePage } from "@/pages/LexofficePage";
import { LoginPage } from "@/pages/LoginPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { Navigate, Route, Routes } from "react-router-dom";

// ============================================================
// App — Routing + Auth Guard
// ============================================================

export function App() {
	const { user, isLoading } = useAuth();

	if (isLoading) {
		return (
			<div className="flex h-full items-center justify-center">
				<div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
			</div>
		);
	}

	if (!user) {
		return (
			<Routes>
				<Route path="/login" element={<LoginPage />} />
				<Route path="*" element={<Navigate to="/login" replace />} />
			</Routes>
		);
	}

	return (
		<Routes>
			<Route element={<Layout />}>
				<Route path="/" element={<DashboardPage />} />
				<Route path="/bookings" element={<BookingsPage />} />
				<Route path="/bookings/new" element={<BookingCreatePage />} />
				<Route path="/bookings/:id" element={<BookingDetailPage />} />
				<Route path="/contacts" element={<ContactsPage />} />
				<Route path="/companies" element={<CompaniesPage />} />
				<Route path="/emails" element={<EmailsPage />} />
				<Route path="/lexoffice" element={<LexofficePage />} />
				<Route path="/health" element={<HealthPage />} />
				<Route path="/settings" element={<SettingsPage />} />
			</Route>
			<Route path="/login" element={<Navigate to="/" replace />} />
			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
	);
}
